import { useMutation, useQueryClient } from '@tanstack/react-query'
import UserService from '../../../services/UserService'

type DeactivateProfilePayload = {
  organization: string
  id: string
}

export const useDeactivateProfile = () => {
  const queryClient = useQueryClient()

  return useMutation<any, Error, DeactivateProfilePayload>({
    mutationKey: ['deactivateProfile'],
    mutationFn: ({ organization, id }) => UserService.deactivateUser(organization, id),
    onSuccess: (_, { organization }) =>
      queryClient.invalidateQueries({ queryKey: ['profile-applications', organization] }),
  })
}
